import { whooshPrimitives } from "./primitives";

export type WhooshInputColorTokens = {
  "input-surface-neutral": string;
  "input-surface-disabled": string;
  "input-surface-read-only": string;
  "input-text-input-neutral": string;
  "input-text-input-hover": string;
  "input-text-input-placeholder": string;
  "input-surface-hover": string;
  "input-surface-pressed": string;
  "input-surface-focused": string;
  "input-text-input-pressed": string;
  "input-text-input-focused": string;
  "input-text-input-active": string;
  "input-surface-active": string;
  "input-text-input-disabled": string;
  "input-text-input-read-only": string;
  "input-outline-neutral": string;
  "input-outline-hover": string;
  "input-outline-focused": string;
  "input-outline-pressed": string;
  "input-outline-active": string;
  "input-outline-read-only": string;
  "input-outline-disabled": string;
  "input-icon-regular": string;
  "input-surface-filled": string;
  "input-surface-error": string;
  "input-text-input-filled": string;
  "input-text-input-error": string;
  "input-outline-filled": string;
  "input-outline-error": string;
  "input-icon-filled": string;
  "input-icon-pressed": string;
  "input-icon-focused": string;
  "input-icon-active": string;
  "input-icon-disabled": string;
  "input-icon-read-only": string;
  "input-icon-error": string;
};

export const whooshInputColors: WhooshInputColorTokens = {
  "input-surface-neutral": whooshPrimitives.grayscale[0],
  "input-surface-disabled": whooshPrimitives.grayscale[100],
  "input-surface-read-only": whooshPrimitives.grayscale[100],
  "input-text-input-neutral": whooshPrimitives.grayscale[900],
  "input-text-input-hover": whooshPrimitives.grayscale[900],
  "input-text-input-placeholder": whooshPrimitives.grayscale[900],
  "input-surface-hover": whooshPrimitives.grayscale[0],
  "input-surface-pressed": whooshPrimitives.grayscale[0],
  "input-surface-focused": whooshPrimitives.grayscale[0],
  "input-text-input-pressed": whooshPrimitives.grayscale[900],
  "input-text-input-focused": whooshPrimitives.grayscale[900],
  "input-text-input-active": whooshPrimitives.grayscale[1000],
  "input-surface-active": whooshPrimitives.grayscale[0],
  "input-text-input-disabled": whooshPrimitives.grayscale[700],
  "input-text-input-read-only": whooshPrimitives.grayscale[1000],
  "input-outline-neutral": whooshPrimitives.grayscale[400],
  "input-outline-hover": whooshPrimitives.grayscale[600],
  "input-outline-focused": whooshPrimitives.grayscale[500],
  "input-outline-pressed": whooshPrimitives.grayscale[700],
  "input-outline-active": whooshPrimitives.grayscale[1000],
  "input-outline-read-only": whooshPrimitives.grayscale[100],
  "input-outline-disabled": whooshPrimitives.grayscale[100],
  "input-icon-regular": whooshPrimitives.grayscale[1000],
  "input-icon-disabled": whooshPrimitives.grayscale[700],
  "input-icon-read-only": whooshPrimitives.grayscale[1000],
  "input-surface-filled": whooshPrimitives.grayscale[0],
  "input-surface-error": whooshPrimitives.grayscale[0],
  "input-text-input-filled": whooshPrimitives.grayscale[1000],
  "input-text-input-error": whooshPrimitives.status.error[500],
  "input-outline-filled": whooshPrimitives.grayscale[400],
  "input-outline-error": whooshPrimitives.status.error[500],
  "input-icon-error": whooshPrimitives.status.error[500],
  "input-icon-filled": whooshPrimitives.grayscale[1000],
  "input-icon-pressed": whooshPrimitives.grayscale[800],
  "input-icon-focused": whooshPrimitives.grayscale[1000],
  "input-icon-active": whooshPrimitives.grayscale[1000],
};
